import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const EdComPage = loadable(() => import('./EdComPage'));
export default {
    id: 'ed_com',
    title: 'Ed-com',
    icon: 'envelop2',
    route: 'ed-com',
    defaultRoute: 'ed-com/notifications',
    hasDynamicDefaultRoute: true,
    group: 'administration',
    component: EdComPage,
    order: 4,
    structure,
};
